module.exports = __webpack_public_path__ + "img/icon-chat.7be6ef8d.svg";